// extracted by mini-css-extract-plugin
export var closed = "_ie-1";
export var resizer = "_ie-0";